import { isApiError, MicroserviceErrorHandler } from '@counsel-project/client-utils'
import logout from '../auth/logout'
import log from '../logging'

const errorHandler: MicroserviceErrorHandler<unknown> = async (err): Promise<void> => {
  if (isApiError(err)) {
    if (err.status === 401) {
      log.info('Session expired, logging out')
      await logout(true)
    }
  }
}

export default errorHandler
